exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.comp-loading--block {\n  padding: 30px 0;\n  text-align: center;\n}\n.comp-loading--inline {\n  display: inline-block;\n  height: 40px;\n  line-height: 40px;\n}\n", "", {"version":3,"sources":["/./src/component/Loading.vue"],"names":[],"mappings":";AAAA;EACE,gBAAgB;EAChB,mBAAmB;CAAE;AAEvB;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;CAAE","file":"Loading.vue","sourcesContent":[".comp-loading--block {\n  padding: 30px 0;\n  text-align: center; }\n\n.comp-loading--inline {\n  display: inline-block;\n  height: 40px;\n  line-height: 40px; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-0d9ed309!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Loading.vue
// module id = 14
// module chunks = 0 1